import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';

var oppositeDirections = {
  top: 'bottom',
  bottom: 'top',
  right: 'left',
  left: 'right'
};
var getOppositePosition = function getOppositePosition(position) {
  return oppositeDirections[position];
};

var splitPlacement = function splitPlacement(placement) {
  return placement.split('-');
};

function getBoxShadow(placement, color) {
  if (placement.includes('top')) {
    return "2px 2px 2px 0 " + color;
  }

  if (placement.includes('bottom')) {
    return "-1px -1px 1px 0 " + color;
  }

  if (placement.includes('right')) {
    return "-1px 1px 1px 0 " + color;
  }

  return "1px -1px 1px 0 " + color;
}
function getArrowStyles(placement, arrowSize, arrowShadowColor) {
  var _ref;

  var _splitPlacement = splitPlacement(placement),
      position = _splitPlacement[0];

  var oppositePosition = getOppositePosition(position);
  if (!oppositePosition) return {};
  return _ref = {}, _ref[oppositePosition] = "-" + arrowSize / 2 + "px", _ref.width = arrowSize, _ref.height = arrowSize, _ref.position = 'absolute', _ref.transform = 'rotate(45deg)', _ref.boxShadow = arrowShadowColor ? getBoxShadow(placement, arrowShadowColor) : undefined, _ref;
}

var toVar = function toVar(value, fallback) {
  return {
    "var": value,
    varRef: fallback ? "var(" + value + ", " + fallback + ")" : "var(" + value + ")"
  };
};

var cssVars = {
  arrowShadowColor: /*#__PURE__*/toVar('--popper-arrow-shadow-color'),
  arrowSize: /*#__PURE__*/toVar('--popper-arrow-size', '8px'),
  arrowSizeHalf: /*#__PURE__*/toVar('--popper-arrow-size-half'),
  arrowBg: /*#__PURE__*/toVar('--popper-arrow-bg'),
  transformOrigin: /*#__PURE__*/toVar('--popper-transform-origin'),
  arrowOffset: /*#__PURE__*/toVar('--popper-arrow-offset')
};
var transforms = {
  top: 'bottom center',
  'top-start': 'bottom left',
  'top-end': 'bottom right',
  bottom: 'top center',
  'bottom-start': 'top left',
  'bottom-end': 'top right',
  left: 'right center',
  'left-start': 'right top',
  'left-end': 'right bottom',
  right: 'left center',
  'right-start': 'left top',
  'right-end': 'left bottom'
};
var toTransformOrigin = function toTransformOrigin(placement) {
  return transforms[placement];
};
var defaultEventListeners = {
  scroll: true,
  resize: true
};
function getEventListenerOptions(value) {
  var eventListeners;

  if (typeof value === 'object') {
    eventListeners = {
      enabled: true,
      options: _extends({}, defaultEventListeners, value)
    };
  } else {
    eventListeners = {
      enabled: value,
      options: defaultEventListeners
    };
  }

  return eventListeners;
}

export { cssVars, getArrowStyles, getBoxShadow, getEventListenerOptions, getOppositePosition, toTransformOrigin };
//# sourceMappingURL=popper.utils.esm.js.map
